import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRulerTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 6L3 3V21H21L18 18M6 6L9 9M6 6L5 7M9 9L12 12M9 9L8 10M12 12L15 15M12 12L11 13M15 15L14 16M15 15L18 18M18 18L17 19M6 12V18H12L6 12Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRulerTriangle;
